import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router)

/**
 * 路由组件
 */
import Login from '../views/login/Login';  // 登录
import Register from '../views/login/Register';  // 注册
import Container from '../components/Container';  // 中间内容容器
import Home from '../views/home/home/index.vue';  // 首页
import MaladyType from '../views/malady/maladyType/index.vue';  // 病症类型
import MaladyAdd from '../views/malady/maladyAdd/index.vue';  // 添加病症
import MaladyList from '../views/malady/maladyList/index.vue';  // 病症列表
import AcupointList from '../views/acupoint/acupointList/index.vue';  // 穴位列表
import AcupointChildList from '../views/acupoint/acupointChildList/index.vue';  // 穴位列表
import NerveList from '../views/acupoint/nerveList/index.vue';  // 经络
import AcupointAdd from '../views/acupoint/acupointAdd/index.vue';  // 添加穴位
import AcupointComment from '../views/comment/acupointComment/index.vue'; // 穴位留言
import MaladyComment from '../views/comment/maladyComment/index.vue';  // 病症留言
import User from '../views/user/index.vue';  // 访客用户
import Carousel from '../views/systemSetting/carousel/index.vue';  // 轮播图
import Menu from '../views/systemSetting/menu/index.vue';  // 菜单
import AdminList from '../views/admin/adminList/index.vue';  // 管理员
import Category from '../views/home/category/index.vue';  // 首页分类


/**
 * 路由
 */
export default new Router({
  routes: [{
    path: '/',
    redirect: '/login'
  }, {
    path: '/login',
    component: Login,
  }, {
    path: '/register',
    component: Register,
  }, {
    path: '/home',
    component: Container,
    children: [
      {
        path: '/',
        component: Home,
        title: "平台数据",
        icon: "el-icon-tickets",
      }, {
        path: '/home',
        component: Home,
        title: "平台数据",
        icon: "el-icon-tickets",
      }, {
        path: '/maladyType',
        component: MaladyType,
        title: "病症分类",
        subTitle: '病症',
        subIndex: '4',
        subIcon: "el-icon-suitcase-1"
      }, {
        path: '/maladyAdd',
        component: MaladyAdd,
        title: "病症添加",
        subTitle: '病症',
        subIndex: '4',
        subIcon: "el-icon-suitcase-1"
      }, {
        path: '/maladyList',
        component: MaladyList,
        title: "病症列表",
        subTitle: '病症',
        subIndex: '4',
        subIcon: "el-icon-suitcase-1"
      }, {
        path: '/acupointList',
        component: AcupointList,
        title: "成人穴位列表",
        subTitle: '穴位',
        subIndex: '5',
        subIcon: "el-icon-news"
      }, {
        path: '/acupointChildList',
        component: AcupointChildList,
        title: "小儿穴位列表",
        subTitle: '穴位',
        subIndex: '5',
        subIcon: "el-icon-news"
      }, {
        path: '/nerveList',
        component: NerveList,
        title: "经络",
        subTitle: '穴位',
        subIndex: '5',
        subIcon: "el-icon-news"
      }, {
        path: '/acupointAdd',
        component: AcupointAdd,
        title: "穴位添加",
        subTitle: '穴位',
        subIndex: '5',
        subIcon: "el-icon-news"
      }, {
        path: '/acupointComment',
        component: AcupointComment,
        title: "穴位留言",
        subTitle: '留言系统',
        subIndex: '2',
        subIcon: "el-icon-chat-line-round"
      }, {
        path: '/maladyComment',
        component: MaladyComment,
        title: "病症留言",
        subTitle: '留言系统',
        subIndex: '2',
        subIcon: "el-icon-chat-line-round"
      }, {
        path: '/user',
        component: User,
        title: "访客管理",
        icon: "el-icon-view"
      }, {
        path: '/carousel',
        component: Carousel,
        title: "轮播图",
        subTitle: '系统设置',
        subIndex: '3',
        subIcon: "el-icon-setting"
      }, {
        path: '/menu',
        component: Menu,
        title: "菜单管理",
        subTitle: '系统设置',
        subIndex: '3',
        subIcon: "el-icon-setting"
      }, {
        path: '/adminList',
        component: AdminList,
        title: "管理员",
        icon: "el-icon-user"
      },
      {
        path: '/category',
        component: Category,
        title: "首页病症分类",
        icon: "el-icon-attract"
      },
    ]
  },
  {
    path: '*',
    component: Login,
  },
  ]
})